import React, { useEffect, useRef, useState } from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"

import Layout from "../../Layout/Layout"
import SEO from "../../seo"
import AboutCompany from "./AboutCompany/AboutCompany"
import Hero from "./Hero/Hero"
import PartnersSlider from "./PartnersSlider/PartnersSlider"
import Testimonials from "./Testimonials/Testimonials"
import FeaturedProjects from "./FeaturedProjects/FeaturedProjects"
import Awards from "./Awards/Awards"


const IndexPage: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	return (
		<Layout location={location}>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "index.seo.description" })}
				title={intl.formatMessage({ id: "index.seo.title" })}
				pathname={location.pathname}
			/>
			<Hero />
			<AboutCompany />
			<PartnersSlider />
			<FeaturedProjects />
			<Testimonials />
			<Awards />
		</Layout >
	)
}

export default IndexPage
